import { useCallback, useMemo, useState } from 'react';

export function useColumnHeaderFilters(initial = {}) {
  const [filters, setFilters] = useState(initial);
  const [editingKey, setEditingKey] = useState(null);

  const setFilter = useCallback((key, value) => {
    setFilters((prev) => {
      const next = { ...prev };
      const trimmed = String(value ?? '').trim();
      if (!trimmed) delete next[key];
      else next[key] = value;
      return next;
    });
  }, []);

  const clearFilter = useCallback((key) => {
    setFilter(key, '');
  }, [setFilter]);

  const hasActiveFilters = useMemo(
    () => Object.values(filters).some((v) => String(v ?? '').trim()),
    [filters],
  );

  return {
    filters,
    setFilter,
    clearFilter,
    editingKey,
    setEditingKey,
    hasActiveFilters,
  };
}

export default useColumnHeaderFilters;
